<template>
    <div>
        <el-upload
            ref="upload"
            action=""
            class="upload-demo"
            :http-request="submitUpload"
            :on-exceed="handleExceed"
            :show-file-list="false"
            :auto-upload="true"
            :limit="1"
            accept='.mp4,.avi,.wmv'
            >
            <el-button type="primary" icon="el-icon-upload2" circle></el-button>
        </el-upload>
    </div>
</template>
<script>
import { uploadPictures } from '../../api/product';
const BYTES_PER_CHUNK = 10 * 1024 * 1024; // 每个文件切片大小定为10MB
export default {
    methods: {
        submitUpload(uploadData) {
            if (uploadData.file.type === 'video/mp4' || uploadData.file.type === 'video/avi' || uploadData.file.type === 'video/wmv') {
                if (uploadData.file.size > BYTES_PER_CHUNK) {
                    this.$message({
                        message: '视频上传只支持10M以内',
                        type: 'warning'
                    });
                    this.$refs.upload.clearFiles();
                } else {
                    this.$message({
                        message: '视频上传中，请不要关闭页面',
                        type: 'success'
                    });
                    this.simpleUpload(uploadData);
                }
            } else {
                this.$message({
                    message: '视频上传类型不正确',
                    type: 'warning'
                });
                this.$refs.upload.clearFiles();
            }
        },
        // 视频上传测试
        simpleUpload(uploadData) {
            const form = new FormData();
            form.append('file', uploadData.file);
            uploadPictures(form).then(res => {
                if (res.code === '0') {
                    this.$emit('pushUrl', res.data.localFileName);
                    this.$message({
                        message: '上传成功',
                        type: 'success'
                    });
                    this.$refs.upload.clearFiles();
                }
            }).catch(() => {
                this.$refs.upload.clearFiles();
            });
        },
        handleExceed(files, fileList) {
            this.$message({
                message: '视频一次只能上传1个',
                type: 'warning'
            });
        }

    }
};
</script>
<style lang="less">

</style>